import createIcon from '../../createIcon';

/**
 * @component @name AppBlocking
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSA4QzE0LjI5IDggMTIuNSA5Ljc5IDEyLjUgMTJDMTIuNSAxNC4yMSAxNC4yOSAxNiAxNi41IDE2QzE4LjcxIDE2IDIwLjUgMTQuMjEgMjAuNSAxMkMyMC41IDkuNzkgMTguNzEgOCAxNi41IDhaTTE0IDEyQzE0IDEwLjYyIDE1LjEyIDkuNSAxNi41IDkuNUMxNi45MiA5LjUgMTcuMyA5LjYxIDE3LjY1IDkuNzlMMTQuMjkgMTMuMTVDMTQuMTEgMTIuOCAxNCAxMi40MiAxNCAxMlpNMTYuNSAxNC41QzE2LjA4IDE0LjUgMTUuNyAxNC4zOSAxNS4zNSAxNC4yMUwxOC43MSAxMC44NUMxOC44OSAxMS4yIDE5IDExLjU4IDE5IDEyQzE5IDEzLjM4IDE3Ljg4IDE0LjUgMTYuNSAxNC41Wk0xNS41IDE4SDUuNVY2SDE1LjVWN0gxNy41VjNDMTcuNSAxLjkgMTYuNiAxIDE1LjUgMUg1LjVDNC40IDEgMy41IDEuOSAzLjUgM1YyMUMzLjUgMjIuMSA0LjQgMjMgNS41IDIzSDE1LjVDMTYuNiAyMyAxNy41IDIyLjEgMTcuNSAyMVYxN0gxNS41VjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AppBlocking = createIcon('AppBlocking', [
  [
    'path',
    {
      d: 'M16.5 8C14.29 8 12.5 9.79 12.5 12C12.5 14.21 14.29 16 16.5 16C18.71 16 20.5 14.21 20.5 12C20.5 9.79 18.71 8 16.5 8ZM14 12C14 10.62 15.12 9.5 16.5 9.5C16.92 9.5 17.3 9.61 17.65 9.79L14.29 13.15C14.11 12.8 14 12.42 14 12ZM16.5 14.5C16.08 14.5 15.7 14.39 15.35 14.21L18.71 10.85C18.89 11.2 19 11.58 19 12C19 13.38 17.88 14.5 16.5 14.5ZM15.5 18H5.5V6H15.5V7H17.5V3C17.5 1.9 16.6 1 15.5 1H5.5C4.4 1 3.5 1.9 3.5 3V21C3.5 22.1 4.4 23 5.5 23H15.5C16.6 23 17.5 22.1 17.5 21V17H15.5V18Z',
      key: '1plohq',
    },
  ],
]);

export default AppBlocking;
